import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/auth-guard/auth-guard.service';

const routes: Routes = [
  // The editorial /new-home is now the index page. `pathMatch: 'full'`
  // restricts this entry to the bare root URL — any sub-path falls
  // through to the master-view tree below, which still owns
  // /products, /cart, /orders, etc.
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () => import('./new-home/new-home.module').then(m => m.NewHomeModule)
  },
  // Existing /new-home bookmarks keep working — they bounce to /.
  {
    path: 'new-home',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: '',
    loadChildren: () => import('./master-view/master-view.module').then(m => m.MasterViewModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'register',
    loadChildren: () => import('./register/register.module').then(m => m.RegisterModule),
  },
  {
    path: 'about',
    loadChildren: () => import('./about-us/about-us.module').then(m => m.AboutUsModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: 'secure',
    loadChildren: () => import('./without-header/without-header.module').then(m => m.WithoutHeaderModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
